
//This function will add '...' to the end of a product title if it is too long for the product box.
function generateProductTitle(elementClass, productTitle, currProdNumber){    
    var maxCharCountToAllowElipsis = 48;    
    var newProdTitle = productTitle;
    var diffBetweenMaxAllowedAndAcutalLength = (newProdTitle.length - maxCharCountToAllowElipsis);
    if(productTitle.length > maxCharCountToAllowElipsis){        
        newProdTitle = newProdTitle.substring(0, newProdTitle.length - (diffBetweenMaxAllowedAndAcutalLength - 3));
        newProdTitle += "...";        
    }

     var products = document.getElementsByClassName( elementClass );         
     products[currProdNumber].innerHTML = newProdTitle;
}

function addPaddingToProducts(elementClass, currProdNumber){

    var products = document.getElementsByClassName( elementClass );   
    var isProductTheFirstInTheRow = ((currProdNumber % 4) == 0 ? true:false);
    console.log("curr prod number: " + isProductTheFirstInTheRow);
    if(!isProductTheFirstInTheRow){
        //products[currProdNumber].style.paddingLeft = "10px"
    }
}

$(document).ready(function() {
    //Make the tooltip show instantly.
    $( ".product-title" ).tooltip({ show: { effect: "none", delay: 0 } });
});